import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function calculateScore(answers) {
  const { data } = await axios.post(`${API}/assessment/calculate`, { answers });
  return data;
}

export async function submitLead(answers, contact, leadIntent = "general_contact") {
  const { data } = await axios.post(`${API}/leads`, {
    answers,
    contact: { ...contact, lead_intent: leadIntent },
  });
  return data;
}

export async function adminLogin(password) {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  return data;
}

export async function fetchLeads(password) {
  const { data } = await axios.get(`${API}/admin/leads`, {
    headers: { "x-admin-password": password },
  });
  return data.leads;
}

export async function updateLeadStatus(password, leadId, status) {
  const { data } = await axios.patch(
    `${API}/admin/leads/${encodeURIComponent(leadId)}/status`,
    { status },
    { headers: { "x-admin-password": password } },
  );
  return data;
}
